<template>
  <div id="app" class="app">
    <mt-header fixed title="应付款逐笔逐项公开">
        <router-link to="./cwl" slot="left">
          <mt-button icon="back"></mt-button>
        </router-link>
    </mt-header>
    <div class="bodyDiv">
      <div class="address">
        <el-row :gutter="20">
          <el-col :span="9">
            <el-date-picker v-model="sdate" type="month" placeholder="开始时间" value-format="yyyyMM"></el-date-picker>
          </el-col>
          <el-col :span="9">
            <el-date-picker v-model="edate" type="month" placeholder="结束时间" value-format="yyyyMM"></el-date-picker>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" @click="pageSearch()">查询</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="certent">
        <div class="cerBotjzjd">
          <div class="jzjdMk mk01">
            <p>收入</p>
            <p class="money"><span>{{yfkList.dai}}</span>元</p>
          </div>
          <div class="jzjdMk mk02">
            <p>支出</p>
            <p class="money"><span>{{yfkList.jie}}</span>元</p>
          </div>
        </div>
      </div>
      <div class="cwdbTab">
        <div class="cerTop">
          <div class="certit"><span class="kuang"></span>应付逐笔逐项公开</div>
        </div>
        <el-table :data="tableData" stripe style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="dt" label="日期"></el-table-column>
          <el-table-column prop="pzh1" label="凭证号"></el-table-column>
          <el-table-column prop="zy" label="摘要"></el-table-column>
          <el-table-column prop="dai" label="收入"></el-table-column>
          <el-table-column prop="jie" label="支出"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { yfkSearch, yfkPage } from "@/api/cwl";
import { doCreate, getDicTab } from "@/utils/config";
export default {
  name: "yfkzbzxgkinfo",
  data() {
    return {
      pagesize: 999,
      start: 0,
      sdate: '',
      edate: '',
      year: '',
      xzqhCode: '',
      active: "",
      activeIndex: "1",
      tableData:[],
      yfkList: [],
      value3: '',
      value4: ''
    };
  },
  methods: {

    //应付款逐笔逐项公开榜-查询
    yfkSearch() {
      let url = "/gk/findYfhz.open?year=" + this.year + "&orgcode=" + this.xzqhCode;
      let _this = this;
      yfkSearch(url).then(res => {
        let data = res.data;
        _this.yfkList = data.result;
      });
    },
    
    //应付款逐笔逐项公开榜-查询
    yfkPage() {
      let url = "/gk/findYfzbzxgk.open?start=" + this.start + "&pagesize=" + this.pagesize + "&sdate=" + this.sdate + "&edate=" + this.edate + "&orgcode=" + this.xzqhCode;
      let _this = this;
      yfkPage(url).then(res => {
        let data = res.data;
        _this.tableData = data.result.content;
      });
    },
    //增加时间条件-查询
    pageSearch(){
      this.yfkPage();
    },
    dicAll() {
        //获取当前年月
        let date = new Date();
        let yearnew = date.getFullYear();
        let month = date.getMonth() + 1;
        if(month < 10){
          this.month = "0" + "" + month
        }
        this.year = yearnew + "" + this.month;
    },
    changeColor(active) {
      if (active == 1) {
        this.$router.push("/cwl");
      } else if (active == 2) {
        this.$router.push("/zcl");
      } else if (active == 3) {
        this.$router.push("/htl");
      }
      this.activeIndex = active;
    },
  },
  mounted() {
    this.xzqhName = window.sessionStorage.getItem("xzqhName");
    this.xzqhCode = window.sessionStorage.getItem("xzqhCode");
    this.dicAll();
    this.yfkSearch();
    this.yfkPage();
  }
};
</script>

<style lang="scss" scoped>
.app {
  font-size: 14px;
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding-top: 40px;
  background: #fff;
  .bodyDiv {
    padding: 0;
    margin: 0;
    flex: 1;
    height: 0;
    overflow: scroll;
  }
  .banner {
    width: 100%;
    height: 160px;
    background: url("../../../public/images/banner.png") no-repeat;
    background-size: 100% 100%;
  }
  .address {
    padding: 10px;
    span {
      display: inline-block;
    }
    .affleft {
      width: 65%;
      padding-right: 10px;
    }
    .addright {
      width: 34%;
    }
  }
  .certent {
    padding: 0 12px 12px 12px;
    background: #fff;
    border-bottom: 10px solid #eee;
    .cerBotjzjd {
      width: 100%;
      height: 100px;
      display: flex;
      border-top: 1px solid #dedede;
      padding: 10px 0 0 0;
      .jzjdMk {
        flex: 1;
        margin: 0 5px;
        padding: 20px 10px 20px 20px;
        line-height: 26px;
        color: #666;
        border-radius: 6px;
        color: #fff;
        .money {
          span {
            font-size: 18px;
          }
        }
      }
      .mk01 {
        background: linear-gradient(to right, #fad15d , #f7842b); /* 标准的语法 */
        background: -webkit-linear-gradient(to right, #fad15d , #f7842b); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(to right, #fad15d , #f7842b); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(to right, #fad15d , #f7842b); /* Firefox 3.6 - 15 */
      }
      .mk02 {
        background: linear-gradient(to right, #69d333 , #27b53d); /* 标准的语法 */
        background: -webkit-linear-gradient(to right, #69d333 , #27b53d); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(to right, #69d333 , #27b53d); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(to right, #69d333 , #27b53d); /* Firefox 3.6 - 15 */
      }
    }
  }
  .cerTop{
    padding: 10px;
    .certit{
      color: #333;
      font-size: 16px;
      height: 30px;
      line-height: 30px;
      .kuang{
        width: 6px;
        height: 22px;
        background: #2a8cef;
        display: inline-block;
        margin-bottom: -4px;
        margin-right: 5px;
      }
    }
  }
  .botNr{
    padding: 10px 12px;
    line-height: 26px;
    color: #666;
  }
}
</style>
<style lang="scss">
.app {
  .mint-header {
    background-color: #2a8cef;
  }
  .mint-header-title {
    font-size: 18px;
  }
  .el-select {
    width: 100%;
  }
  .el-table th{
    background:#ddecff;
    color:#333;
  }
}
</style>
